import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

/**
 * JoinStore — smart resolver behind the shareable /join/:id link.
 * Opens the store's LIVE stream if one is running, otherwise lands the
 * customer on the store page with an invite prompt to follow for alerts.
 */
export default function JoinStore() {
  const { id } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/stores/${id}`);
        if (cancelled) return;
        const live = (data.streams || []).find((st) => st.is_live);
        if (live) nav(`/live/${live.stream_id}`, { replace: true });
        else nav(`/store/${id}?invite=1`, { replace: true });
      } catch {
        if (!cancelled) nav(`/store/${id}?invite=1`, { replace: true });
      }
    })();
    return () => { cancelled = true; };
  }, [id, nav]);

  return (
    <div className="p-10 text-center text-[#A1A1AA]" data-testid="join-store-loading">
      Opening the sale…
    </div>
  );
}
